// ===== 配置部分 =====
import axios from "@/assets/js/axios";

const API_URL = "api/order/view-speak-order"; // ✅ 替换为你的订单接口
const BIG_ORDER_THRESHOLD = 1000; // 大额订单阈值
const FETCH_INTERVAL = 10 * 60 * 1000; // 10分钟
const SPEAK_INTERVAL = 2 * 60 * 1000; // 播放每条语音间隔
let  time = null;
// ===== 工具函数 =====
let voiceReady = false;

function unlockSpeech() {
	if (!voiceReady) {
		const test = new SpeechSynthesisUtterance('语音播报已开启');
		window.speechSynthesis.speak(test);
		voiceReady = true;
		//console.log('✅ SpeechSynthesis 已解锁');
		mainTask(); // 启动时先执行一次
		clearInterval(time)
		time = setInterval(mainTask, FETCH_INTERVAL); // 每隔10分钟执行一次
	}
}

document.addEventListener('click', unlockSpeech, {once: true});

// 获取北京时间
function getBeijingDate() {
	return new Date();
}

function playDingDong(order) {
	if (order.amount_cny >= BIG_ORDER_THRESHOLD) {
		return;
	}
	const ctx = new (window.AudioContext || window.webkitAudioContext)();
	const now = ctx.currentTime;

	// // ---- 轻“叮”（前奏） ----
	// const lightDing = ctx.createOscillator();
	// const gain1 = ctx.createGain();
	// lightDing.type = 'sine';
	// lightDing.frequency.setValueAtTime(1320, now);
	// gain1.gain.setValueAtTime(0.05, now);
	// gain1.gain.exponentialRampToValueAtTime(0.001, now + 0.6);
	// lightDing.connect(gain1).connect(ctx.destination);
	// lightDing.start(now);
	// lightDing.stop(now + 0.3);

	// ---- 主“叮” ----
	const ding = ctx.createOscillator();
	const gain2 = ctx.createGain();
	ding.type = 'triangle';
	ding.frequency.setValueAtTime(1046.5, now + 1);
	gain2.gain.setValueAtTime(0.6, now + 1);
	gain2.gain.exponentialRampToValueAtTime(0.001, now + 1.6);
	ding.connect(gain2).connect(ctx.destination);
	ding.start(now + 1);
	ding.stop(now + 1.6);

	// ---- “咚” ----
	const dong = ctx.createOscillator();
	const gain3 = ctx.createGain();
	dong.type = 'sine';
	dong.frequency.setValueAtTime(523.25, now + 1.6);
	gain3.gain.setValueAtTime(0.7, now + 1.6);
	gain3.gain.exponentialRampToValueAtTime(0.001, now + 2.3);
	dong.connect(gain3).connect(ctx.destination);
	dong.start(now + 1.6);
	dong.stop(now + 2.3);
}


// 语音播报
function speak(text) {

	const utter = new SpeechSynthesisUtterance(text);

	utter.lang = "zh-CN";
	utter.rate = 0.9;
	utter.pitch = 1.8
	setTimeout(() => {
		speechSynthesis.speak(utter);
	}, 1000)

}

// 从后台获取订单
async function fetchOrders() {
	try {
		const res = await axios.get(API_URL)

		return await res.data.data; // { orders: [...], total_amount, total_orders }
	} catch (err) {
		console.error("❌ 获取订单失败:", err);
		return null;
	}
}

// 获取播报内容
function getOrderSpeech(order) {

	if (order.amount_cny >= BIG_ORDER_THRESHOLD) {
		return `重磅战报！一笔${order.amount_cny}元的重磅订单诞生了！这是${order.name}的高光时刻！`;
	} else {

		return `${order.name}收到一笔来自${order.country}的新订单，金额${order.amount_cny}元。`;
	}
}

// 播放汇总语音
function speakSummary(totalOrders, totalAmount) {
	const text = `大家早上好！过去一天我们收回了${totalOrders}个订单，总金额${totalAmount}元。新的一天，继续加油！`;
	speak(text);
}

// 保存最后播报的时间标记
function markSummaryPlayed(dateStr) {
	localStorage.setItem("summary_played_date", dateStr);
}

function hasPlayedSummaryToday() {
	const last = localStorage.getItem("summary_played_date");
	const today = getBeijingDate().toDateString();
	return last === today;
}

// 记录已播报的订单 ID
function getPlayedOrderIds() {
	return JSON.parse(localStorage.getItem("played_orders") || "[]");
}

function markOrdersPlayed(ids) {
	const played = getPlayedOrderIds();
	const newList = [...new Set([...played, ...ids])];
	localStorage.setItem("played_orders", JSON.stringify(newList));
}

// ===== 主任务逻辑 =====

export async function mainTask() {
	const now = getBeijingDate();
	const hour = now.getHours();

	// 夜间不请求
	if (hour < 9 || hour >= 19) {
		console.log("🌙 夜间时间，不请求。", now.toLocaleTimeString("zh-CN"));
		return;
	}

	// 拉取订单数据
	const result = await fetchOrders();
	//console.log(result);
	if (!result || !result.orders) return;

	const {orders, total_amount, count} = result;

	// 9:00 每天第一次请求播报汇总语音
	if (hour >= 9 && !hasPlayedSummaryToday()) {
		speakSummary(count, total_amount);
		markSummaryPlayed(now.toDateString());
		await new Promise(r => setTimeout(r, 3000));
		//return; // 汇总语音当天只播一次
	}

	// 其他时间播报订单
	const played = getPlayedOrderIds();
	const unplayedOrders = orders.filter(o => !played.includes(o.id));

	if (unplayedOrders.length === 0) {
		console.log("📭 没有新订单");
		return;
	}

	// 随机取3条
	const toPlay = unplayedOrders.sort(() => 0.5 - Math.random()).slice(0, 3);

	//console.log("📢 播报订单:", toPlay);

	for (const order of toPlay) {
		await new Promise(r => setTimeout(r, Math.random() * SPEAK_INTERVAL + 30000));
		playDingDong(order)
		await new Promise(r => setTimeout(r, 1000));
		speak(getOrderSpeech(order));


	}

	// 标记已播报
	markOrdersPlayed(toPlay.map(o => o.id));
}

// ===== 定时器 =====


